export default function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiL2hvbWUvY2lyY2xlY2kvcHJvamVjdC9ub2RlX21vZHVsZXMvQGJhYmVsL3J1bnRpbWUvaGVscGVycy9vYmplY3RXaXRob3V0UHJvcGVydGllc0xvb3NlL19pbmRleC5tanMiXSwKICAibWFwcGluZ3MiOiAiQUFBQSxzREFBc0QsUUFBUSxVQUFVO0FBQ3RFLE1BQUksVUFBVTtBQUFNLFdBQU87QUFDM0IsTUFBSSxTQUFTO0FBQ2IsTUFBSSxhQUFhLE9BQU8sS0FBSztBQUM3QixNQUFJLEtBQUs7QUFFVCxPQUFLLElBQUksR0FBRyxJQUFJLFdBQVcsUUFBUSxLQUFLO0FBQ3RDLFVBQU0sV0FBVztBQUNqQixRQUFJLFNBQVMsUUFBUSxRQUFRO0FBQUc7QUFDaEMsV0FBTyxPQUFPLE9BQU87QUFBQTtBQUd2QixTQUFPO0FBQUE7IiwKICAibmFtZXMiOiBbXQp9Cg==
